var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-2"},[_c('h1',[_vm._v("Language tool")]),_vm._l((_vm.translationTree),function(value,attr){return _c('translation-level',{key:attr,attrs:{"attr":attr,"value":value,"secret":_vm.secret}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }